import { requestUploadReturnDocuments } from '@/api/processes-api'
import { toast } from '@itsrever/design-system'
import { useProcessAction } from './use-process-action'

interface RequestUploadDocs {
  processId: string
  message?: string
}

export function useRequestUploadDocs() {
  return useProcessAction({
    action: ({ processId, message }: RequestUploadDocs) =>
      requestUploadReturnDocuments(processId, message),
    errorText: 'Error requesting documents',
    onSuccess: () =>
      toast({ variant: 'success', text: 'Documents requested successfully' })
  })
}
